<template>
  <o-form ref="form" :title="$t('medtastic.sponsor')" :url="'/api/medtastic/sponsors/' + $route.params.id + '?include=sponsor_checkboxes'"
          class="ortic-form-horizontal">
    <template slot-scope="props">
      <b-row>
        <b-col>
          <o-input v-model="props.item.name" :errorField="'name'" :label="$t('core.name')"/>
          <o-input v-model="props.item.link" :errorField="'link'" :label="$t('core.link')"/>
          <o-file-upload v-model="props.item.picture" :label="$t('medtastic.picture')" accept="image/*"/>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
    </template>
    <template slot="child" slot-scope="props">
      <b-tabs>
        <b-tab :title="$t('medtastic.sponsor_checkboxes')" active>
          <o-card>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('core.label') }}</th>
                  <th class="text-right">
                    <b-btn variant="primary" @click.prevent="open()">
                      <fa icon="plus"/>
                    </b-btn>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(checkbox, i) in props.item.sponsor_checkboxes">
                  <td v-html="checkbox['label_' + locale]" class="markdown"></td>
                  <td class="text-right text-nowrap">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <b-btn variant="secondary" @click.prevent="props.item.sponsor_checkboxes.splice(i, 1)">
                        <fa icon="times"/>
                      </b-btn>
                      <b-btn variant="primary" @click.prevent="open(i)">
                        <fa icon="pencil-alt"/>
                      </b-btn>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </o-card>
        </b-tab>
      </b-tabs>
      <b-modal id="modal-add-edit" ref="addEditModal" :ok-title="$t('core.save')" :title="$t('core.checkbox')"
               size="lg" @ok="ok" @shown="onModalShown">
        <b-row>
          <b-col>
            <o-form-group :label="$t('core.label_en')" :class="{'d-none': !Object.keys(locales).includes('en')}">
              <div class="input-group">
                <o-summernote-editor v-model="formSchema.label_en" ref="editorEn" />
              </div>
            </o-form-group>
            <o-form-group :label="$t('core.label_de')" :class="{'d-none': !Object.keys(locales).includes('de')}">
              <div class="input-group">
                <o-summernote-editor v-model="formSchema.label_de" ref="editorDe" />
              </div>
            </o-form-group>
          </b-col>
          <b-col>
            <o-form-group :label="$t('core.label_fr')" :class="{'d-none': !Object.keys(locales).includes('fr')}">
              <div class="input-group">
                <o-summernote-editor v-model="formSchema.label_fr" ref="editorFr" />
              </div>
            </o-form-group>
            <o-form-group :label="$t('core.label_it')" :class="{'d-none': !Object.keys(locales).includes('it')}">
              <div class="input-group">
                <o-summernote-editor v-model="formSchema.label_it" ref="editorIt" />
              </div>
            </o-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </template>
  </o-form>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  data: () => ({
    i: null,
    formSchema: {}
  }),
  computed: mapGetters({
    locale: 'lang/locale',
    locales: 'lang/locales',
    user: 'auth/user'
  }),
  methods: {
    onModalShown() {
      this.$refs.editorEn.initEditor()
      this.$refs.editorDe.initEditor()
      this.$refs.editorFr.initEditor()
      this.$refs.editorIt.initEditor()
    },
    open(i = null) {
      this.reset()
      this.i = i
      if (this.i !== null) {
        this.formSchema = Object.assign({}, this.formSchema, this.$refs.form.item.sponsor_checkboxes[this.i])
      }
      this.$refs.addEditModal.show()
    },
    ok() {
      if (this.i !== null) {
        this.$set(this.$refs.form.item.sponsor_checkboxes, [this.i], this.formSchema)
      } else {
        const length = this.$refs.form.item.sponsor_checkboxes.length
        delete this.formSchema.id
        this.$set(this.$refs.form.item.sponsor_checkboxes, [length], this.formSchema)
      }

      this.$refs.addEditModal.hide()
    },
    reset() {
      this.formSchema = Object.assign({}, this.formSchema, {
        label_en: null,
        label_de: null,
        label_fr: null,
        label_it: null
      })
      this.i = null
    }
  }
}
</script>
<style>
#modal-add-edit___BV_modal_outer_ {
  z-index: 1050 !important;
}
</style>
